import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: '[appIconName]',
})
export class IconNameDirective implements OnInit {
  @Input() public appIconName!: string | undefined;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private matIcon: MatIcon
  ) {}

  public ngOnInit(): void {
    const matIconEl = this.element.nativeElement;

    if (this.appIconName?.startsWith('custom-')) {
      this.matIcon.svgIcon = this.appIconName;
    } else {
      this.renderer.removeAttribute(matIconEl, 'svgIcon');
      this.renderer.setProperty(matIconEl, 'textContent', this.appIconName);
    }
  }
}
